import React, { Component } from "react";
import styled from "styled-components";
import IconFooter from "../module-common/IconFooter";
import { send } from "../Socket";
import SendMessage from "../assets/Sending.png";
import moment from "moment";
import { Config } from "../constant";

export default class MessageInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chatInput: "",
      isTyped: false,
      isActive: false,
      height: "20px"
    };
    this.submitHandler = this.submitHandler.bind(this);
    this.textChangeHandler = this.textChangeHandler.bind(this);
  }
  updateSize = height => {
    this.setState({
      height
    });
  };
  textChangeHandler(event) {
    if (event.target.value.length <= 0) {
      this.setState({
        chatInput: "",
        isTyped: false
      });
    } else {
      this.setState({
        chatInput: event.target.value,
        isTyped: true
      });
    }
  }
  submitHandler(event) {
    event.preventDefault();
    this.setState({ chatInput: "" });
    this.props.onSend(this.state.chatInput);
  }

  handleKeyPress = e => {
    if (e.key === "Enter") {
      var ms = moment()
        .millisecond(0)
        .valueOf();
      let message = JSON.stringify({
        code: "message:send",
        sessionId: localStorage.getItem(Config.domainId()),
        type: "text",
        text: this.state.chatInput,
        timestamp: ms
      });
      send(message);
      this.setState({ chatInput: "" });
    }
  };
  render() {
    const { isTyped, height } = this.state;
    let newStyle = {
      height
    };
    return (
      <Wrapper>
        <MessageInputWrapper>
          <InputSec
            style={newStyle}
            editable={true}
            multiline={true}
            onChange={this.textChangeHandler}
            value={this.state.chatInput}
            placeholder="Type your message here..."
            onContentSizeChange={e =>
              this.updateSize(e.nativeEvent.contentSize.height)
            }
            onKeyPress={this.handleKeyPress}
          />
        </MessageInputWrapper>
        <IconWrapper>
          {isTyped ? (
            <IconFooter
              image={SendMessage}
              isSmall={true}
              isActive={true}
              onClick={this.onSendMessage}
            /> // <IconFooter image={Picture} isSmall={true} />
          ) : (
            <IconFooter
              image={SendMessage}
              isSmall={true}
              isActive={false}
              onClick={this.onSendMessage}
            />
          )}
        </IconWrapper>
      </Wrapper>
    );
  }

  onSendMessage = () => {
    var ms = moment()
      .millisecond(0)
      .valueOf();
    let message = JSON.stringify({
      code: "message:send",
      sessionId: localStorage.getItem(Config.domainId()),
      type: "text",
      text: this.state.chatInput,
      timestamp: ms
    });
    send(message);
    this.setState({
      chatInput: ""
    });
  };
}

const InputSec = styled.input`
  background-color: transparent;
  overflow: visible;
  width: 120%;
  border: 0px;
  font-size: 11px;
  font-family: "Source Sans Pro", sans-serif;
  font-style: Regular;
  color: #4d4f5c
  align-self:center;
  &:focus {
    outline: none;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
  width: 100%;
  height: 40px;
  background: #f5f6fa;
  justify-content: space-between;
  border-top: 1px solid #e7e7e7;
  border-bottom: 1px solid #e7e7e7;
  &:focus-within {
    background: white;
    box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.16);
  }
  ::placeholder {
    color: #a4afb7;
  }
`;
const MessageInputWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin-right: 20px;
  margin-left: 10px;
`;

const IconWrapper = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  align-self: center;
  margin-right: 17px;
`;



// WEBPACK FOOTER //
// ./src/module-common/MessageInput.js